import React, { Component } from 'react';
import { Fstyr } from '../../components/FstyrComponents/Fstyr.js';
import { fetchModel } from '../../components/HelperComponents/FetchExtension';
import { OrderVm } from '../../Models/OrderVm';
import URL from '../../Constants/URL.js'
import { DateFormatterWithTime } from '../../components/HelperComponents/DateFormatter'

enum cardTypes {
    foererkort = "Førerkort",
    vaerkstedskort = "Værkstedskort",
    virksomhedskort = "Virksomhedskort",
    kontrolkort = "Kontrolkort",
}

type Props = {};

type State = {
    cardType: cardTypes;
    filterFailed: boolean;
    searchQuery: string;
    orders: OrderVm[];
    newestFirst: boolean;
    page: number;
    showSpinner: boolean;
    showRemovalModal: boolean;
    showNoteModal: boolean;
    currentOrder: OrderVm | null;
};

export class Bestillingsoversigt extends Component<Props, State> {
    static displayName = Bestillingsoversigt.name;
    private toastRef: React.RefObject<any>;
    private baseState: State;
    private maxResults = 20;

    constructor(props: Props) {
        super(props);
        this.toastRef = React.createRef();

        var initialCardType = cardTypes.foererkort;

        this.state = {
            cardType: initialCardType,
            filterFailed: false,
            searchQuery: "",
            orders: [],
            newestFirst: true,
            page: 1,
            showSpinner: false,
            showRemovalModal: false,
            showNoteModal: false,
            currentOrder: null,
        };

        this.baseState = this.state
    }

    componentDidMount(): void {
        this.fetchOrders()
    }

    //#region api kald 

    search = (searchType: string, searchString: string): void => {
        var query = ""
        if (searchString) {
            // OBS det her håndterer kun de originale searchtypes. 
            // overvej en bedre stuktur hvis der kommer flere searchtypes i fremtiden-. 
            searchType = searchType.replace("-", "").split("/")[0]
            query = `&${searchType}=${searchString}`
        }
        this.setState({ searchQuery: query }, () =>
            this.fetchOrders())
    }

    fetchOrders = (): void => {
        this.setState({ orders: [], showSpinner: true, page: 1 })

        var query: string = `?cardType=${this.getTypeChar(this.state.cardType)}`
        if (this.state.filterFailed)
            query += "&filterFailed=true"
        query += this.state.searchQuery

        fetchModel("GET", URL + "/api/order/GetCardOrders", query, OrderVm)
            .then(model => {
                this.setState({ orders: model.sort((a, b) => ((a.OprettetDato ?? 0) < (b.OprettetDato ?? 0)) && this.state.newestFirst ? 1 : -1) })
            })
            .catch(error => {
                if (error !== "No result")
                    this.showErrorToast(`Something went wrong cardtype is ${this.state.cardType}, the error is ${error}`)
            })
            .finally(
                () => this.setState({ showSpinner: false })
            )
    }

    removeOrder = () => {
        if (!this.state.currentOrder)
            this.showErrorToast("En bestilling blev forsøgt fjernet med currentOrder var null.")

        let success = true
        fetch(`${URL}/api/order/SetOrderStatusToProcessed/${this.state.currentOrder?.BestillingsId}`, { method: "PATCH" })
            .then((result) => {
                if (result.status !== 200)
                    success = false
            })
            .catch(() => {
                success = false;
            })
            .finally(
                () => {
                    success ? this.successToast("Bestillingen blev fjernet.")
                        : this.showErrorToast("Bestillingen blev ikke fjernet.")
                    this.setState(this.baseState, () => this.fetchOrders())
                }
            )
    }

    saveNote = (note: string) => {
        if (!this.state.currentOrder)
            this.showErrorToast("En note blev forsøgt tilføjet med currentOrder var null.")
        let success = true
        // OBS. the replaceAll preserves new lines when processing the string toa valid http request.
        fetch(`${URL}/api/order/UpdateNote/${this.state.currentOrder?.BestillingsId}/?note=${note.replaceAll("\n", "%0D%0A")}`, { method: "PATCH" })
            .then((result) => {
                if (result.status !== 200)
                    success = false
            })
            .catch(() => {
                success = false;
            })
            .finally(
                () => {
                    success ? this.successToast("Bestillingens note blev opdateret.")
                        : this.showErrorToast("Bestillingens note blev ikke opdateret.")
                    this.setState(this.baseState, () => this.fetchOrders())
                }
            )
    }

    //#endregion api kald 
    //#region api helpers

    getSearchTypes(): string[] {
        var searchTypes: string[] = ["Bestillings-Id"]
        switch (this.state.cardType) {
            case cardTypes.foererkort:
                searchTypes.push("Cpr")
                break;
            case cardTypes.vaerkstedskort:
                searchTypes.push("Cvr")
                break;
            case cardTypes.virksomhedskort:
                searchTypes.push("Cvr/Cpr")
                break;
            case cardTypes.kontrolkort:
                searchTypes.push("Myndighedskode")
                break;
        }
        return searchTypes
    }

    getTypeChar(cardType: cardTypes): string {
        switch (cardType) {
            case cardTypes.foererkort:
                return "F"
            case cardTypes.vaerkstedskort:
                return "W"
            case cardTypes.virksomhedskort:
                return "V"
            case cardTypes.kontrolkort:
                return "K"
        }
    }

    //#endregion api helpers
    //#region table management
    getHeaders(): Array<JSX.Element | string> {
        var columnHeaders: Array<JSX.Element | string> = ["Id", this.getOprettetHeader()]
        switch (this.state.cardType) {
            case cardTypes.foererkort:
                columnHeaders = columnHeaders.concat(["CPR", "Fornavn", "Efternavn"])
                break;
            case cardTypes.vaerkstedskort:
                columnHeaders = columnHeaders.concat(["CVR", "Værkstedsnavn"])
                break;
            case cardTypes.virksomhedskort:
                columnHeaders = columnHeaders.concat(["CVR/CPR", "Virksomhedsnavn"])
                break;
            case cardTypes.kontrolkort:
                columnHeaders = columnHeaders.concat(["ID-nummer", "Myndighed"])
                break;
        }
        columnHeaders = columnHeaders.concat(["Status", "Note", "Fjern"]);
        return columnHeaders
    }

    getOprettetHeader(): JSX.Element {
        return (
            <div className='header-sortable' onClick={() => this.toggleSort()}>
                {"Oprettet"}
                <i className={`icon icon-arrow-drop-${this.state.newestFirst ? "down" : "up"}`}></i>
            </div>
        )
    }

    toggleSort = () =>
        this.setState({
            page: 1,
            orders: this.state.orders.sort((a, b) => ((a.OprettetDato ?? 0) < (b.OprettetDato ?? 0)) && !this.state.newestFirst ? 1 : -1),
            newestFirst: !this.state.newestFirst
        })


    getTableData(): Array<Array<JSX.Element | string>> {
        var startIndex = (this.state.page * this.maxResults) - this.maxResults
        var endIndex = Math.min(this.state.page * this.maxResults, this.state.orders.length)
        return this.state.orders.slice(startIndex, endIndex).map(order => {
            switch (this.state.cardType) {
                case cardTypes.foererkort:
                    return [
                        order.BestillingsId,
                        <div style={{ whiteSpace: "nowrap" }}>
                            {DateFormatterWithTime(order.OprettetDato?.toString())}</div>,
                        order.Cpr,
                        order.Fornavn,
                        order.Efternavn,
                        order.BestillingsStatus,
                        <div
                            title={order.Note}
                            className={`link ellipsis ${order.Note ? "" : "invisible-cell"}`}
                            onClick={() => { this.openNoteModal(order) }}
                        >
                            {order.Note ? order.Note : "Tilføj note"}
                        </div>,
                        <div className='link' onClick={() => { this.openRemovalModal(order) }}>Fjern</div>
                    ]
                case cardTypes.vaerkstedskort:
                case cardTypes.virksomhedskort:
                    return [
                        order.BestillingsId,
                        <div style={{ whiteSpace: "nowrap" }}>
                            {DateFormatterWithTime(order.OprettetDato?.toString())}</div>,
                        order.Cvr,
                        order.CvrNavn,
                        order.BestillingsStatus,
                        <div
                            title={order.Note}
                            className={`link ellipsis ${order.Note ? "" : "invisible-cell"}`}
                            onClick={() => { this.openNoteModal(order) }}
                        >
                            {order.Note ? order.Note : "Tilføj note"}
                        </div>,
                        <div className='link' onClick={() => { this.openRemovalModal(order) }}>Fjern</div>
                    ]
                case cardTypes.kontrolkort:
                    return [
                        order.BestillingsId,
                        <div style={{ whiteSpace: "nowrap" }}>
                            {DateFormatterWithTime(order.OprettetDato?.toString())}</div>,
                        order.WrxNr,
                        order.MyndighedsKode,
                        order.BestillingsStatus,
                        <div
                            title={order.Note}
                            className={`link ellipsis ${order.Note ? "" : "invisible-cell"}`}
                            onClick={() => { this.openNoteModal(order) }}
                        >
                            {order.Note ? order.Note : "Tilføj note"}
                        </div>,
                        <div className='link' onClick={() => { this.openRemovalModal(order) }}>Fjern</div>
                    ]
                default:
                    return []
            }
        })
    }

    getTableNote(): string {
        let len = this.state.orders.length
        if (len > 0) {
            if (len <= this.maxResults)
                return `Der er ${len} resultat${len === 1 ? "" : "er"}.`
            return `Viser ${(this.state.page * this.maxResults) - this.maxResults + 1} - ${Math.min(this.state.page * this.maxResults, len)} ud af ${len} bestillinger`
        }
        else return "Der er ingen resultater."
    }

    //#endregion table management
    //#region other page management

    // Toasts

    successToast = (message: string) =>
        this.toastRef.current.show("Success", message, "success")

    showErrorToast = (error: string) =>
        this.toastRef.current.show("Fejl", error, "error")

    // Modals

    openNoteModal = (order: OrderVm) =>
        this.setState({ showNoteModal: true, currentOrder: order })

    closeNoteModal = () =>
        this.setState({ showNoteModal: false, currentOrder: null })

    openRemovalModal = (order: OrderVm) =>
        this.setState({ showRemovalModal: true, currentOrder: order })

    closeRemovalModal = () =>
        this.setState({ showRemovalModal: false, currentOrder: null })

    // Other

    handleCardTypeButton(cardType: cardTypes) {
        if (cardType !== this.state.cardType) {
            this.setState({ cardType: cardType }, () => this.fetchOrders())
        }
    }

    handleCheckbox = (value: boolean) =>
        this.setState({ filterFailed: value }, () => this.fetchOrders())

    handlePageButtons = (increase: boolean) =>
        this.setState({ page: increase ? this.state.page + 1 : this.state.page - 1 })

    //#endregion other page management

    render() {
        return (
            <>
                <Fstyr.Toast ref={this.toastRef} />

                <Fstyr.Modal
                    show={this.state.showRemovalModal}
                    onAccept={this.removeOrder}
                    onDecline={this.closeRemovalModal}
                    label="Er du sikker på at du vil fjerne bestillingen?"
                    buttonAcceptLabel="Fjern Bestilling"
                    buttonDeclineLabel="Annullér"
                />
                <Fstyr.NoteModal
                    show={this.state.showNoteModal}
                    onAccept={this.saveNote}
                    onDecline={this.closeNoteModal}
                    label="Rediger note"
                    value={this.state.currentOrder?.Note ?? ""}
                />

                <Fstyr.Segment
                    title="Bestillingsoversigt"
                    isPageTitle={true}
                >
                    <div className="fstyr-left-button-group">
                        {Object.values(cardTypes).map((type) => { 
                            return (
                                <Fstyr.Button
                                    label={type}
                                    type={this.state.cardType === type ? "primary" : "secondary"}
                                    onClick={() => this.handleCardTypeButton(type)}
                                />
                            )
                        })}
                    </div>
                </Fstyr.Segment>

                <Fstyr.Segment title="Søgning og filtrering placeholder" >
                    <div style={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap", alignItems: "center", gap: 30 }}>
                        <Fstyr.DropdownSearch
                            dropDownItems={this.getSearchTypes()}
                            search={this.search}
                            showSpinner={this.state.showSpinner}
                        />
                        <Fstyr.Checkbox
                            label="Vis kun fejlede bestillinger"
                            checked={this.state.filterFailed}
                            onClick={this.handleCheckbox}
                        />
                    </div>
                </Fstyr.Segment>

                <Fstyr.Segment title={`Bestillinger - ${this.state.cardType}`} >
                    <Fstyr.Table
                        headers={this.getHeaders()}
                        data={this.getTableData()}
                        addClassToRow={(index: number) => { return this.state.orders[(this.state.page * this.maxResults) - this.maxResults + index].BestillingsStatus === "Fejlet" ? "error-row" : "" }}
                        note={this.getTableNote()}
                    />

                    <div className='fstyr-right-button-group'>
                        <Fstyr.Button
                            label={"Færre"}
                            type={"secondary"}
                            disabled={this.state.page === 1}
                            onClick={() => this.handlePageButtons(false)}
                        />
                        <Fstyr.Button
                            label={"Flere"}
                            type={"secondary"}
                            disabled={this.state.page * this.maxResults >= this.state.orders.length}
                            onClick={() => this.handlePageButtons(true)}
                        />
                    </div>
                </Fstyr.Segment>
            </>
        );
    }

}
